import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const Field = ({ id, label, required, ...props }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-sm font-semibold text-[#0A192F]">{label}{required && <span className="text-[#FF2E63]"> *</span>}</Label>
    <Input id={id} required={required} className="h-11 bg-white focus-visible:ring-[#FF2E63]" data-testid={`input-${id}`} {...props} />
  </div>
);
